export const ErrorNotices = {
    ERROR_NOTICE: 'NOTICE::DEFAULT_ERROR',
    FAILED_CONVERSATIONS_LOAD: 'NOTICE::FAILED_CONVERSATIONS_LOAD',
    FAILED_MESSAGES_LOAD: 'NOTICE::FAILED_MESSAGES_LOAD',
    NOT_FOUND: 'NOTICE::NOT_FOUND',
    ACCOUNT_MISMATCH: 'NOTICE::ACCOUNT_MISMATCH',
};

export const MobileNotices = {
    ...ErrorNotices,
    NO_ARCHIVED_CONVERSATIONS: 'NOTICE::NO_ARCHIVED_CONVERSATIONS',
    NO_CONVERSATIONS: 'NOTICE::NO_CONVERSATIONS',
    NO_SPAM_CONVERSATIONS: 'NOTICE::NO_SPAM_CONVERSATIONS',
    WELCOME: 'NOTICE::WELCOME',
};

export const DesktopNotices = {
    ...MobileNotices,
    AVAILABLE_CONVERSATIONS: 'NOTICE::AVAILABLE_CONVERSATIONS',
};

export const MessagingNotices = {
    ...DesktopNotices,
    ...MobileNotices,
};

export const MobileConversationPaneNotices = [MobileNotices.FAILED_MESSAGES_LOAD];
export const MobileConversationListPaneNotices = Object.values(MobileNotices).filter(
    (notice) => !MobileConversationPaneNotices.includes(notice)
);

export const NOTICE_CARD_MSG_CLASS = '.notice-card-message';
